import { selectPromoInventory } from './selectPromoInventory';
import { IApplicationState } from '../../types/redux';

export function selectActiveBannerIndex(state: IApplicationState) {
  const promoInventory = selectPromoInventory(state);

  return promoInventory.activeBannerIndex;
}
